function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.27539 7.87495C4.27539 6.88084 5.08128 6.07495 6.07539 6.07495H15.5254C16.5195 6.07495 17.3254 6.88084 17.3254 7.87495V15.525C17.3254 16.5191 16.5195 17.325 15.5254 17.325H6.07539C5.08128 17.325 4.27539 16.5191 4.27539 15.525V7.87495Z",
    stroke: "black",
    style: {
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 4.27502V7.42502",
    stroke: "black",
    style: {
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4004 4.27502V7.42502",
    stroke: "black",
    style: {
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97461 9.67505H14.6246",
    stroke: "black",
    style: {
      stroke: "black",
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.aa35284f3721334184f1811bcf189cb9.svg";
export { ForwardRef as ReactComponent };